import { Conversation, UserAddress } from "@swivl-mono/types";

export function IsConversationActive(conversation: Conversation): boolean {
  if (typeof conversation.lastSeen === "string") {
    conversation.lastSeen = new Date(conversation.lastSeen);
  }
  return conversation.lastSeen && conversation.lastSeen.getTime() > new Date().getTime() - 1000 * 10 ? true : false;
}
export function URLFromAddress(address?: UserAddress): string {
  if (address) {
    return `${address.origin}${address.pathname}`;
  }
  return "";
}
